import { defineContent, type DefinedContent } from '@post-office/define-content';

export const registeredContent: DefinedContent<
	['headingLabel', 'bodyLabel', 'callToActionLabel', 'dismissLabel']
> = defineContent({
	default: {
		headingLabel: {
			id: 'post-office.confluence-create-with-rovo-side-nav-nudge.heading',
			defaultMessage: 'You describe, Rovo creates',
			description: 'Heading for the Create with Rovo side nav nudge.',
			role: 'title',
		},
		bodyLabel: {
			id: 'post-office.confluence-create-with-rovo-side-nav-nudge.body',
			defaultMessage: 'With a simple prompt, Rovo can draft a page or whiteboard.',
			description: 'Body text for the Create with Rovo side nav nudge.',
			role: 'description',
		},
		callToActionLabel: {
			id: 'post-office.confluence-create-with-rovo-side-nav-nudge.call.to.action',
			defaultMessage: 'Show me how',
			description: 'Call to action button on the Create with Rovo side nav nudge.',
		},
		dismissLabel: {
			id: 'post-office.confluence-create-with-rovo-side-nav-nudge.dismiss',
			defaultMessage: 'Dismiss',
			description: 'Dismiss button on the Create with Rovo side nav nudge.',
		},
	},
});
